<template>
  <el-row
    class="d-flex justify-center align-center text-center"
    style="height: 100%; margin: auto"
  >
    <el-col>
      <svg-not-found v-if="!useImg && !useSvg" />
      <img
        v-else-if="useImg && !useSvg"
        height="255px"
        width="255px"
        :src="require(`@/assets/img/${useImg}`)"
      />
      <img
        v-else
        height="255px"
        width="255px"
        :src="require(`@/assets/svg/${useSvg}?inline`)"
      />

      <h1 class="custom-color heading-1 my-0">
        {{ mainText || $t('components.page-not-found') }}
      </h1>
      <p class="custom-color heading-2 my-0 opa-70">
        {{ subText || $t('components.try-later') }}
      </p>
      <el-button
        size="small"
        style="margin-top: 10px"
        v-if="haveReloadBtn"
        @click="$emit('click-reload')"
      >
        {{ $t('components.try') }}
      </el-button>
    </el-col>
  </el-row>
</template>

<script>
const svgNotFound = () => import("@/assets/svg/not-found.svg");
// const fridge = () => import('@/assets/svg/fridge.svg')

export default {
  name: "NothingToSeeHere",
  props: {
    useImg: String,
    useSvg: String,
    mainText: String,
    subText: String,
    haveReloadBtn: Boolean,
  },
  components: {
    svgNotFound,
    // fridge,
  },
  computed: {},
};
</script>

<style>
.custom-color {
  color: #4d5078;
}
</style>